import React from "react";
export const RiverSidebarContext = React.createContext(null);
